import { useEffect, useState, useCallback } from "react";
import { getImpersonationStatus, stopImpersonation } from "../lib/api";
import { setImpersonation, useImpersonation } from "../lib/impersonation";
import { Icon } from "./Common.jsx";

// Detects impersonation (feature #6), publishes it to the global impersonation
// state (so useRole switches into the tenant view), and shows a persistent
// "Exit impersonation" banner. Admins keep their own session underneath.
export default function ImpersonationBanner() {
  const imp = useImpersonation();
  const [exiting, setExiting] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const s = await getImpersonationStatus();
      if (s?.active) {
        setImpersonation({ active: true, role: s.user?.role || null, user: s.user, company: s.company });
      } else {
        setImpersonation({ active: false, role: null, user: null, company: null });
      }
    } catch {
      setImpersonation({ active: false, role: null, user: null, company: null });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const exit = async () => {
    setExiting(true);
    try { await stopImpersonation(); } catch {}
    setImpersonation({ active: false, role: null, user: null, company: null });
    window.location.assign("/app"); // full reset back to the admin view
  };

  if (!imp.active) return null;

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 200,
        background: "linear-gradient(90deg, #b45309, #d97706)",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        padding: "8px 16px",
        fontSize: 13.5,
        fontWeight: 600,
        flexWrap: "wrap",
      }}
    >
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Icon name="eye" size={15} />
        Viewing as <strong>{imp.user?.name || imp.user?.email}</strong>
        {imp.company?.name ? <span style={{ opacity: 0.85 }}>· {imp.company.name}</span> : null}
      </span>
      <button
        onClick={exit}
        disabled={exiting}
        style={{
          background: "rgba(0,0,0,.22)",
          color: "#fff",
          border: "1px solid rgba(255,255,255,.35)",
          borderRadius: 8,
          padding: "4px 12px",
          fontSize: 12.5,
          fontWeight: 700,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <Icon name="log-out" size={13} /> {exiting ? "Exiting…" : "Exit impersonation"}
      </button>
    </div>
  );
}
